var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionPadlockUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 76,
    viewBox: "0 0 82 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.2494,
    cy: 50.1793,
    rx: 25.2494,
    ry: 25.0191,
    fill: "#6C5CE7",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8173 17.7103C53.5544 12.8329 49.0986 9.23077 43.8005 9.23077C37.5183 9.23077 32.4255 14.2934 32.4255 20.5385V23.7692H60.0508C65.4356 23.7692 69.8008 28.1086 69.8008 33.4615V59.3077C69.8008 64.6606 65.4356 69 60.0508 69H27.5508C22.166 69 17.8008 64.6606 17.8008 59.3077V33.4615C17.8008 28.1086 22.166 23.7692 27.5508 23.7692H29.1755V20.5385C29.1755 12.5091 35.7234 6 43.8005 6C50.6174 6 56.3412 10.6349 57.9647 16.905C58.1884 17.769 57.6651 18.6497 56.796 18.8721C55.9269 19.0945 55.041 18.5743 54.8173 17.7103ZM27.5508 27C23.9609 27 21.0508 29.8929 21.0508 33.4615V59.3077C21.0508 62.8763 23.9609 65.7692 27.5508 65.7692H60.0508C63.6406 65.7692 66.5508 62.8763 66.5508 59.3077V33.4615C66.5508 29.8929 63.6406 27 60.0508 27H27.5508Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4258 49.4118C48.2293 48.6945 50.3008 46.1647 50.3008 43.1538C50.3008 39.5852 47.3906 36.6923 43.8008 36.6923C40.2109 36.6923 37.3008 39.5852 37.3008 43.1538C37.3008 46.1647 39.3723 48.6945 42.1758 49.4118V52.8462C42.1758 53.7383 42.9033 54.4615 43.8008 54.4615C44.6982 54.4615 45.4258 53.7383 45.4258 52.8462V49.4118ZM47.0508 43.1538C47.0508 44.9381 45.5957 46.3846 43.8008 46.3846C42.0059 46.3846 40.5508 44.9381 40.5508 43.1538C40.5508 41.3695 42.0059 39.9231 43.8008 39.9231C45.5957 39.9231 47.0508 41.3695 47.0508 43.1538Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPadlockUnlock);
export default __webpack_public_path__ + "static/media/action-padlock-unlock.a624675bf8841504151a38b484dd7a0a.svg";
export { ForwardRef as ReactComponent };